import supabase from '@/api/supabase';
import { endOfWeek, format, startOfWeek } from 'date-fns';
import { TaskRecord } from './types';

export const fetchDayRecords = async (fullDate: string): Promise<TaskRecord[]> => {
  const startOfDay = `${fullDate}T00:00:00`;
  const endOfDay = `${fullDate}T23:59:59`;

  try {
    const { data, error } = await supabase
      .from('taskManager_history')
      .select('name, income, supplies, credits, checkinTime, empUserId')
      .gte('checkinTime', startOfDay)
      .lte('checkinTime', endOfDay);

    if (error) {
      console.error('Error fetching records:', error);
      return [];
    }

    if (data) {
      return data
        .filter(record => record && record.checkinTime)
        .map(record => ({
          name: record.name || 'Unknown',
          income: record.income || 0,
          supplies: record.supplies || 0,
          credits: record.credits || 0,
          checkinTime: record.checkinTime,
        }));
    }
  } catch (err) {
    console.error('Failed to fetch records:', err);
  }

  return [];
};

export const getWeekRange = (date: Date) => {
  // Get the start of week (Monday) and end of week (Sunday)
  const start = startOfWeek(date, { weekStartsOn: 1 }); // 1 = Monday
  const end = endOfWeek(date, { weekStartsOn: 1 });

  // Format dates as MM/dd
  return {
    start: format(start, 'MM/dd'),
    end: format(end, 'MM/dd'),
  };
};
